import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { RadioModel } from "../../../personal-data/model/radio.model";
import { DomainDataService } from "./domain-data.service";
import { DomainDataType } from "./model/domain-data-type";
import { DomainBrokerType } from "./model/domain-broker-type.model";
import { DomainOrigin } from "./model/domain-origin";
import { DomainUtil } from "./domain-util";

@Injectable({
  providedIn: "root",
})
export class DomainDataMobileBrokerService implements DomainDataService {
  private readonly domainTypes = [
    new DomainConvertionItem(
      DomainDataType.DocumentType,
      new DomainBrokerType("tipos_documento", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.City,
      new DomainBrokerType("cidades", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.Country,
      new DomainBrokerType("paises", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.Gender,
      new DomainBrokerType("generos", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.DocumentIssuing,
      new DomainBrokerType("emissores", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.MaritalStatus,
      new DomainBrokerType("estados_civis", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.OriginIncome,
      new DomainBrokerType("origens_renda", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.Profession,
      new DomainBrokerType("profissoes", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.State,
      new DomainBrokerType("estados", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.Nationality,
      new DomainBrokerType("nacionalidades", "1")
    ),
    new DomainConvertionItem(
      DomainDataType.CountryNif,
      new DomainBrokerType("validacoes_nif_paises", "1")
    ),
  ];

  constructor(private handlerService: HandlerService) {}

  public async getDomains(
    domainDataType: DomainDataType,
    parameter?: any
  ): Promise<RadioModel[]> {
    const dataCache = DomainUtil.getDomainFromCache(
      this.getOrigin(),
      domainDataType,
      parameter
    );

    if (dataCache && dataCache.length > 0) {
      return Promise.resolve(dataCache);
    } else {
      const domains = await this.getDataFromRemote(domainDataType, parameter);
      DomainUtil.saveDomainInCache(
        this.getOrigin(),
        domainDataType,
        domains,
        parameter
      );
      return Promise.resolve(domains);
    }
  }

  private async getDataFromRemote(
    domainDataType: DomainDataType,
    parameter?: any
  ): Promise<RadioModel[]> {
    const domainType = this.getDomainType(domainDataType);
    const relCaronte = "aberturaconta-consulta-dominios-cadastro";
    const dataCaronte = {
      nomeDominio: domainType.name,
      filtro: parameter,
    };

    return this.handlerService
      .caronteCommunicator(relCaronte, null, null, false, dataCaronte)
      .then((data: any) => {
        if (data && data.data) {
          switch (domainType.name) {
            case "tipos_documento":
              return Promise.resolve(data.data.map(toDomainOtherModel));
            case "emissores":
              return Promise.resolve(data.data.map(toDomainOtherModel));
            case "generos":
              return Promise.resolve(data.data.map(toDomainGenderModel));
            case "origens_renda":
              return Promise.resolve(data.data.map(toDomainOriginIncomerModel));
            case "validacoes_nif_paises":
              return Promise.resolve(data.data.map(toDomainCountryNifModel));
            default:
              return Promise.resolve(data.data.map(toDomainModel));
          }
        } else {
          return Promise.resolve([]);
        }
      });
  }

  private getDomainType(domainTypeItem: DomainDataType): DomainBrokerType {
    return this.domainTypes.find((r) => r.domainDataType === domainTypeItem)
      ?.domainType;
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.BrokerMobile;
  }
}

export class DomainConvertionItem {
  domainDataType: DomainDataType;
  domainType: DomainBrokerType;
  constructor(_domainDataType: DomainDataType, _domainType: DomainBrokerType) {
    this.domainDataType = _domainDataType;
    this.domainType = _domainType;
  }
}

function toDomainModel(item) {
  return new RadioModel(item.codigo, item.valor, item.valor);
}

function toDomainOtherModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].sigla,
    item.campos_adicionais[0].sigla
  );
}

function toDomainGenderModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].descricao,
    item.valor
  );
}

function toDomainOriginIncomerModel(item) {
  const additionalFields = {
    incomeRequired: item.campos_adicionais[0].renda_obrigatoria,
    patrimonyRequired: item.campos_adicionais[0].patrimonio_obrigatorio,
  };
  return new RadioModel(item.codigo, item.valor, item.valor, additionalFields);
}

function toDomainCountryNifModel(item) {
  const additionalFields = [
    {
      validacoes_nif: {
        minimo_caracteres: item.camposAdicionais[0].validacoesNif.minimoCaracteres,
        preenchimento_obrigatorio: item.camposAdicionais[0].validacoesNif.preenchimentoObrigatorio,
        maximo_caracteres: item.camposAdicionais[0].validacoesNif.maximoCaracteres,
        tamanhos_permitidos: item.camposAdicionais[0].validacoesNif.tamanhosPermitidos,
        formato: item.camposAdicionais[0].validacoesNif.formato,
        caracteres_especiais_nao_permitidos: item.camposAdicionais[0].validacoesNif.caracteresEspeciaisNaoPermitidos,
      },
    },
  ];
  return new RadioModel(item.codigo, item.valor, item.valor, additionalFields);
}
